import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { type: "Follow-up", outcome: "", notes: "", next_action: "", next_action_date: "" };

export default function LogActivityDialog({ open, onOpenChange, onSaved }) {
  const meta = useMeta();
  const [act, setAct] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setAct({ ...act, [k]: e.target.value });

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/activities", act);
      toast.success("Activity logged");
      setAct(EMPTY);
      onOpenChange(false);
      onSaved?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="log-activity-dialog">
        <DialogHeader><DialogTitle>Log activity</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Type</Label>
            <Select value={act.type} onValueChange={(v) => setAct({ ...act, type: v })}>
              <SelectTrigger className="mt-1.5" data-testid="activity-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>{(meta.activity_types || []).map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label>Outcome</Label><Input className="mt-1.5" value={act.outcome} onChange={set("outcome")} data-testid="activity-outcome-input" /></div>
          <div><Label>Notes</Label><Textarea className="mt-1.5" rows={2} value={act.notes} onChange={set("notes")} data-testid="activity-notes-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Next action</Label><Input className="mt-1.5" value={act.next_action} onChange={set("next_action")} data-testid="activity-next-action-input" /></div>
            <div><Label>Next date</Label><Input type="date" className="mt-1.5" value={act.next_action_date} onChange={set("next_action_date")} data-testid="activity-next-date-input" /></div>
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button><Button onClick={save} disabled={busy} className="bg-teal hover:bg-teal-700" data-testid="save-activity-btn">Save</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
